<template>
    <div :class="singleItemClass" @click="emitEvent({ name: 'make-referral', payload: item })">
        <div class="search-results">
            <!-- PHYSICIAN -->
            <div class="avatar-container">
                <img :src="returnAvatar" />
            </div>
            <div class="user-info-container">
                <p>
                    <span>{{ item.name }}</span>
                    <span v-if="item.referral">
                        <span class="user-info-description">
                            {{
                                $t('elements.search_autocomplete.referral_type', {
                                    type: item.referral.type,
                                    date: returnFormatedDate,
                                })
                            }}
                        </span>
                    </span>
                    <span v-else>
                        <span v-if="item.isPhysician" class="user-info-description">
                            {{ userInfoDescription(item) }}
                        </span>
                        <span v-else class="user-info-description">
                            {{ $t('elements.search_autocomplete.referral_type', { address: item.ancillary_address }) }}
                        </span>
                    </span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import PracticePlanEnum from '@/enums/PracticePlanEnum'

    export default {
        props: {
            item: { type: Object, required: true },
            disableNetworkPlan: { type: Boolean, default: false },
        },

        data() {
            return {
                userId: null,
                queryParams: {},
            }
        },

        computed: {
            returnAvatar() {
                if (this.item?.role) {
                    if (this.item?.avatar && this.item.avatar['thumb-360']) return this.item.avatar['thumb-360']
                } else {
                    if (this.item?.image && this.item.image['thumb-360']) return this.item.image['thumb-360']
                }

                return require('./../../../../src/images/avatar-placeholder.png')
            },

            calculateInitials() {
                let nameSplit = this.item.name.split(' ')
                let initials = ''

                for (let i = 0; i < nameSplit.length; i++) {
                    initials += nameSplit[i][0]
                }

                return initials
            },

            isDisabled() {
                return this.disableNetworkPlan && this.item.subscription === PracticePlanEnum.NETWORK
            },

            singleItemClass() {
                return {
                    'search-autocomplete__single-item': true,
                    'search-autocomplete__single-item--disabled': this.isDisabled,
                }
            },

            userid() {
                return this.userId
            },

            returnQueryParams() {
                return this.queryParams
            },

            returnFormatedDate() {
                return dayjs(this.item.referral.date).format('MM-DD-YY')
            },
        },
        methods: {
            userInfoDescription(item) {
                return `${item.primarySpeciality}, ${item.practiceCity} (${item.practiceState})`
            },
        },
    }
</script>
